import axios from 'axios'

export default {
    namespaced: true,
    state: {
        meetings: [],
    },
    getters: {
        getListMeetings: state => state.meetings,
    },
    mutations: {
        setListMeetings: (state, meetings) => {
            state.meetings = meetings
        },
    },
    actions: {
        joinMeeting(ctx, queryParams) {
            return new Promise((resolve, reject) => {
                axios
                    .post('user-meetings', queryParams)
                    .then(response => {
                        ctx.commit('setListMeetings', response.data.data.meetings)
                        resolve(response)
                    })
                    .catch(error => {
                        console.log(error)
                        reject(error)
                    })
            })
        },
    },
}